import storage from 'redux-persist/es/storage'
import { persistCombineReducers } from 'redux-persist'
import { i18nReducer as i18n } from 'react-redux-i18n'
import { reducer as toastr } from 'react-redux-toastr'
import auth from './auth'
import data from './data'
import qrDiagnostics from './qr-diagnostics'
import meta from './meta'

const config = { key: `marking-backend-${process.env.APP_VERSION}`, keyPrefix: process.env.APP_VERSION, storage, whitelist: ['auth'] };
export default persistCombineReducers(config, { auth, data, i18n, toastr, qrDiagnostics, meta });
